import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import BlogApp from "./BlogApp";
import { SubdomainRouter } from "./lib/subdomain";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SubdomainRouter
      subdomains={[{ subdomain: "blog", component: <BlogApp /> }]}
      main={
        <BrowserRouter>
          <App />
        </BrowserRouter>
      }
    />
  </React.StrictMode>,
);
